import React, { useRef } from 'react';
import { Tooltip } from 'shared/components/ui/tooltip';

import * as Styled from './event.style';
import { useTimeBasedStyle } from './use-time-based-style';

export type ExternalEventProps = {
  name: string;
  url?: string;
  color?: string;
  startDate?: string;
  endDate?: string;
};

export const ExternalEvent: React.FC<ExternalEventProps> = ({
  name,
  url,
  color,
  startDate,
  endDate,
}) => {
  const containerRef = useRef<any>(null);
  const { marginTop, lineHeight, numberOfLines } = useTimeBasedStyle(
    startDate,
    endDate,
  );

  return (
    <Styled.ExternalContainer
      as={url ? 'a' : undefined}
      href={url}
      target="_blank"
      rel="noreferrer"
      $color={color}
      ref={containerRef}
    >
      <Styled.Title
        $marginTop={marginTop}
        $lineHeight={lineHeight}
        $completed={false}
        $numberOfLines={numberOfLines}
      >
        {name}
      </Styled.Title>
      <Tooltip referenceElement={containerRef} label={name} delay={400} />
    </Styled.ExternalContainer>
  );
};
